module.exports = __webpack_public_path__ + "assets/img/00118.850101ad.png";